/* RESPONSIBLE TEAM: team-ai-insights */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type CustomReportsService from 'embercom/services/custom-reports-service';

export default class CustomerSatisfactionV2Route extends IntercomRoute {
  @service declare customReportsService: CustomReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
